import { Component, OnInit, inject } from '@angular/core';
import { SharedService } from 'src/app/Shared/shared-service.service';

import { ActivatedRoute } from '@angular/router';
import { EnrichedRG, ReserveGroup } from 'src/model/reserveGroup.model';
import { ProfileService } from 'src/services/profile.service';
import { ReserveGroupService } from 'src/services/reserve-group.service';
import { ViewReserveGroupsComponent } from '../view-reserve-groups/view-reserve-groups.component';

@Component({
    selector: 'app-unsubmitted-reserve-group-list',
    templateUrl: './unsubmitted-reserve-group-list.component.html',
    styleUrl: './unsubmitted-reserve-group-list.component.scss',
    standalone: false
})
export class UnsubmittedReserveGroupListComponent implements OnInit {
  private profileService = inject(ProfileService);
  private rgService = inject(ReserveGroupService);
  private sharedService = inject(SharedService);
  private activatedRoute = inject(ActivatedRoute);

  unsubmittedReserveGroups: ReserveGroup[] = [];
  rgList: any = [];

  routeSubscription: any;
  selectedCompanyId: number;

  async ngOnInit(): Promise<void> {

    this.routeSubscription = this.activatedRoute.paramMap.subscribe(async params => {
      this.selectedCompanyId = + params.get('companyId');

    })

    this.unsubmittedReserveGroups = await this.rgService.getAllReserveGroup({ valid: false, companyId: this.selectedCompanyId ?? undefined });
    if (this.unsubmittedReserveGroups != undefined && this.unsubmittedReserveGroups.length > 0)
      this.rgList = await this.addCustomerDetailsToRG();
  }

  async addCustomerDetailsToRG(): Promise<EnrichedRG[]> {
    const uniqueProfileIds = new Set(this.unsubmittedReserveGroups.map(r => r.SharedProfileId));
    const customers = await this.profileService.getCustomersByProfileIds({ sharedProfileIds: [...uniqueProfileIds] })
    return this.unsubmittedReserveGroups.map(r => {
      const erg: EnrichedRG = r;
      erg.customer = customers.find(c => c.SharedProfileId == r.SharedProfileId);
      return erg;

    });
  }

  goToReserveGroup(id: number) {
    const modalRef = this.sharedService.openModal(ViewReserveGroupsComponent, "regularModal");
    modalRef.componentInstance.reserveGroupId = id;
  }

}
